/** The tooltip every interactive chart shares: a dark label placed over a chart's wrapper.
 *
 * It is a visual duplicate of text a mark already carries as its accessible name, so it is
 * `aria-hidden`; what matters is that it appears on **focus** as well as on hover (WCAG 1.4.13's
 * spirit: a keyboard user gets the same figures). `x` and `y` are pixels inside the chart wrapper
 * (`position: relative`), and it is placed above the point and centred on it.
 */

import type { ReactNode } from "react";

import styles from "./ChartTooltip.module.css";
import type { TipAnchor } from "./tipAnchor";

export function ChartTooltip({ anchor, children }: { anchor: TipAnchor | null; children: ReactNode }) {
  if (!anchor) return null;
  return (
    <div
      className={styles.tip}
      style={{ left: anchor.x, top: anchor.y }}
      aria-hidden="true"
      data-testid="chart-tooltip"
    >
      {children}
    </div>
  );
}
